import { render, staticRenderFns } from "./ListOrderValidatedComponent.vue?vue&type=template&id=b7066f48&"
import script from "./ListOrderValidatedComponent.vue?vue&type=script&lang=js&"
export * from "./ListOrderValidatedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports